/**
 * Renders a value of unknown type as display text.
 *
 * Objects and arrays are deliberately dropped rather than stringified: their
 * default form is `[object Object]`, which is never what a user should see.
 */
export const toDisplayString = (value: unknown, fallback = ''): string => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number')
    return Number.isNaN(value) ? fallback : `${value}`;
  if (typeof value === 'boolean' || typeof value === 'bigint')
    return `${value}`;
  if (value instanceof Date) return value.toISOString();
  return fallback;
};
